class TextTruncation extends HTMLElement {
  constructor() {
    super();
  }

  get readMoreButton() {
    return this.querySelector(':scope > a');
  }

  get truncationContainer() {
    return this.querySelector('[data-truncation-container]');
  }

  connectedCallback() {
    if (!this.readMoreButton || !this.truncationContainer) return;

    this.readMoreClickHandler = this.handleReadMoreClick.bind(this);
    this.readMoreButton.addEventListener('click', this.readMoreClickHandler);

    // Hide "Read more" when the text fits within the line limit
    this.updateButtonVisibility = this.updateButtonVisibility.bind(this);
    this.resizeObserver = new ResizeObserver(this.updateButtonVisibility);
    this.resizeObserver.observe(this.truncationContainer);
    this.updateButtonVisibility();
  }

  disconnectedCallback() {
    this.readMoreButton?.removeEventListener('click', this.readMoreClickHandler);
    this.resizeObserver?.disconnect();
  }

  updateButtonVisibility() {
    const container = this.truncationContainer;
    // When expanded, keep the "Read less" button
    if (container.classList.contains('active')) return;

    const isTruncated = container.scrollHeight > container.clientHeight + 1;
    this.readMoreButton.style.display = isTruncated ? '' : 'none';
  }

  handleReadMoreClick() {
    const container = this.truncationContainer;
    const expanded = !container.classList.contains('active');
    container.classList.toggle('active', expanded);

    // While expanded: clamp to "Lines after Read more", or show everything if it's 0
    const expandedLines = parseInt(container.dataset.expandedLines, 10) || 0;
    const expandStyles = expandedLines > 0
      ? {
          display: '-webkit-box',
          '-webkit-box-orient': 'vertical',
          '-webkit-line-clamp': String(expandedLines),
          'max-height': `calc(1lh * ${expandedLines})`,
          overflow: 'hidden',
        }
      : {
          display: 'block',
          '-webkit-line-clamp': 'unset',
          'max-height': 'none',
          overflow: 'visible',
        };

    Object.entries(expandStyles).forEach(([property, value]) => {
      if (expanded) {
        container.style.setProperty(property, value, 'important');
      } else {
        container.style.removeProperty(property);
      }
    });

    this.readMoreButton.innerText = expanded
      ? this.readMoreButton.dataset.readLess
      : this.readMoreButton.dataset.readMore;
  }
}

customElements.define("text-truncation", TextTruncation);